<template>
    <div class="h-screen w-full flex items-center justify-center">
        <div
            class="relative py-[30px] px-[40px] text-center rounded-[10px] shadow-[0px_0px_10px_0px_#0000001A] border-[10px] border-[#fff] bg-[#fff]">
            <div class="absolute top-0 left-0 w-full h-full rounded-[10px] overflow-hidden">
                <img src="../../../assets/images/thankuSecBg.svg" alt="Thankyou Bg"
                    class="w-full h-full object-cover rounded-[10px]">
            </div>
            <div class="relative z-10">
                <div class="flex justify-center">
                    <img src="../../../assets/images/fyxify-round-logo.svg" alt="Partner Logo"
                        class="w-[100px] h-[100px]  rounded-full border-[3px] border-[#fff]">
                </div>
                <h2 class="my-[15px] font-roboto text-[50px] font-medium text-[#A084E8]">Thank You</h2>
                <p class="my-[15px] font-roboto text-[20px] font-medium text-[#BA90C6]">Order ID: {{ $route?.query?.order_id ?? '-' }}</p>
                <h6 class="m-0 font-roboto text-[25px] font-medium text-[#333]">Congratulations!</h6>
                <p class="m-0 font-roboto text-[16px] font-normal text-[#333]">You are now protected with a protection
                    plan
                    by <br> <span class="!font-roboto text-[16px] font-semibold text-[#333]">OMEGA.</span></p>
                <button @click="onContinueClicked()"
                    class="mt-[20px] px-[30px] py-[10px] rounded-full text-roboto text-[15px] font-semibold text-[#fff] bg-[#00B7C2]">Continue</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            bgImage: require('../../../assets/images/thankuSecBg.svg')
        };
    },
    methods:{
        onContinueClicked(){
                this.$router.replace("/protection-plan/nrg/bundle-list")
        }   
    }
};
</script>